module.exports = __webpack_public_path__ + "static/img/103054.9b84da45.png";